const useTabFocus = () => {
  const handleKeyDown =  (event) => {
    if(event.key === "Enter" || event.key === " "){
      try{
        event.preventDefault();
        event.target.click();
      } catch (e){
        console.debug("Error while handling key down event on tabble element")
      }
    }
  }
  return {handleKeyDown}
};

export default useTabFocus;
